export enum SidebarStateKey {
  Opened = 'opened',
}

export interface SidebarState {
  [SidebarStateKey.Opened]?: boolean;
}
